import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

/**
 * Replaces `material-ui-banner` StaticBanner (master). QA reference:
 * white strip, message left-aligned in the content row, DISMISS far right
 * vertically centered with the text block (material-ui-banner used flex-start + label).
 */
function AdminMessageBanner({ open, message = '', onDismiss }) {
  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Box
        component="div"
        sx={{
          width: '100%',
          bgcolor: '#ffffff',
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Container maxWidth="lg" disableGutters={false} sx={{ px: { xs: 2, sm: 3 }, py: 1.25 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 2,
            }}
          >
            <Typography
              variant="body2"
              component="div"
              sx={{
                flex: '1 1 auto',
                minWidth: 0,
                textAlign: 'left',
                color: 'text.primary',
              }}
            >
              {message}
            </Typography>
            <Button
              variant="text"
              size="small"
              onClick={onDismiss}
              sx={{
                flex: '0 0 auto',
                alignSelf: 'center',
                whiteSpace: 'nowrap',
                color: 'text.primary',
                fontWeight: 500,
                letterSpacing: '0.04em',
                textTransform: 'uppercase',
                minWidth: 'auto',
                minHeight: 0,
                px: 1,
                py: 0,
                lineHeight: 1.43,
                mt: 0,
                mb: 0,
              }}
            >
              Dismiss
            </Button>
          </Box>
        </Container>
      </Box>
    </Collapse>
  );
}

AdminMessageBanner.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string,
  onDismiss: PropTypes.func.isRequired,
};

export default AdminMessageBanner;
